import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    user: false,
    tokenId: localStorage.getItem("logintoken"),
    custId: localStorage.getItem("custId"),
    tabList: [ //存放tab
      //初始页面
      {
        func_url: '/Document/typeDocument',
        label: 'API类型管理',
        func_name: 'API类型管理',
        icon: 'Document'
      }
    ],
    historyTabList:[]
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    },
    // 退出
    logout(state, user) {
      state.user = "";
      localStorage.setItem("userInfo", "");
    },
    setTokenId(state, id) {
      state.tokenId = id;
      localStorage.setItem("logintoken", id);
    },
    setCustId(state, id) {
      state.custId = id;
      if (id) {
        localStorage.setItem("custId", id);
      } else {
        localStorage.setItem("custId", '');
      }
    },
    selectMenu(state, value) {
      //1、默认有一个首页不被删除的，
      //2、【如果不是首页的情况下】点击其他页面添加进来。
      //3、如果点击多次，会放进来多次。所以需要一个去重
      console.log(state)
      if (value.func_name !== 'API类型管理') {
        if(state.tabList.length > 20) {
          state.tabList.shift()
          state.historyTabList.shift()
        }
        let result = state.tabList.findIndex(item => item.func_name === value.func_name)
        result === -1 ? state.tabList.push(value) : ""
        let historyResult = state.historyTabList.findIndex(item => item.func_name === value.func_name)
        if(result === -1) {
          state.historyTabList.push(value)
        } else {
          state.historyTabList.splice(historyResult, 1)
          state.historyTabList.push(value)
        }
      }
    },
    //处理Tabs
    closeTab(state, value) {
      let result = state.tabList.findIndex(item => item.func_name === value.func_name)
      state.tabList.splice(result, 1)
      let historyResult = state.historyTabList.findIndex(item => item.func_name === value.func_name)
      state.historyTabList.splice(historyResult, 1)
    },
    //清空state
    clear(state) {
      state.tabList = []
      state.historyTabList = []
    },
  },
  getters: {
    custId(state) {
      return state.custId
    },
    tokenId(state) {
      return state.tokenId
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js